import { create } from "zustand";
import { api, CreateGoalInput, Goal, UpdateGoalPatch } from "../lib/tauri";

interface GoalState {
  goals: Goal[];
  loaded: boolean;
  /** フォーカス中の枝（null = ルート一覧）。タスクカードのパンくずチップからも設定される */
  focusId: string | null;
  load: () => Promise<void>;
  setFocus: (id: string | null) => void;
  create: (input: CreateGoalInput) => Promise<void>;
  update: (id: string, patch: UpdateGoalPatch) => Promise<void>;
  remove: (id: string) => Promise<void>;
}

export const useGoalStore = create<GoalState>((set, get) => ({
  goals: [],
  loaded: false,
  focusId: null,
  load: async () => {
    try {
      const goals = (await api.listGoals?.()) ?? [];
      set({ goals, loaded: true });
    } catch {
      // PWA など未対応環境: 空で動かす（ゴールタブは案内表示のみ。projectStore と同型）
      set({ goals: [], loaded: true });
    }
  },
  setFocus: (focusId) => set({ focusId }),
  create: async (input) => {
    await api.createGoal?.(input);
    await get().load();
  },
  update: async (id, patch) => {
    await api.updateGoal?.(id, patch);
    await get().load();
  },
  remove: async (id) => {
    await api.deleteGoal?.(id);
    await get().load();
  },
}));
